import { usePrintableWorksheetsState } from 'printableWorksheets/state'
import React from 'react'
import './styles.scss'
import {Grades} from '../../state';
import PrintableWorksheetsEvents from 'printableWorksheets/events';
import { WorksheetsEnvironment } from 'printableWorksheets';

const GradeSelector = () => {
  const { activeGrade, onboardingGrade, setActiveGrade, worksheetsEnvironment} = usePrintableWorksheetsState();

  const gradesToTitleMapper: any = {
    [Grades.ALL_GRADES]: 'All Grades',
    [Grades.PK]: 'Pre-K',
    [Grades.K]: 'K',
    [Grades.ONE]: '1',
    [Grades.TWO]: '2',
    [Grades.THREE]: '3',
    [Grades.FOUR]: '4',
    [Grades.FIVE]: '5',
  }

  const setGradeAndFireEvent = (grade: string) => {
    setActiveGrade(Grades[grade]);
    
    const props = {
      clickedOn: 'Grade Selector',
      grade: onboardingGrade,
      newTopicSelected: '',
      newGradeSelected: grade,
    };
    PrintableWorksheetsEvents.interactedPrintablesFilters(props);
  }

  return (
    <div className='grade-selector'>
      <span className='heading'>Grade</span>
      <div className='grades-container'>
        {
          Object.keys(Grades).filter((grade: Grades) => {
            if(worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD){
              if(Grades[grade] == Grades.PK)
                return false;
              else return true
            } else {
              return true;
            }
          }).map((grade: Grades, index: any)=> {
            return <div key={grade+index} onClick={()=> setGradeAndFireEvent(grade)} className={`grade ${Grades[grade] == activeGrade ? 'selected' : ''}`} >{gradesToTitleMapper[Grades[grade]]}</div>
          })
        }
      </div>
    </div>
  )
}

export default GradeSelector